import { ContentType } from 'common/constants'
import { StoreContentFilter } from 'common/types/entities/store'
import { fetchNews } from 'common/services/news'
import { StateKey } from 'common/utils/flipState'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'
import { NewsParam } from 'common/types/params'
import { NewsState } from 'common/types/entities/news'
const initialState: StoreContentFilter = {
  channelNo: null,
  contentTypes: [],
  contentType: null,
  cacheParam: null,
}

const FETCH = '/store/fashionBrand/contentFilter/FETCH'
const SET = '/store/fashionBrand/contentFilter/SET'

export const fetchContentTypes = (
  curState: StateKey,
  channelNo: string,
  types: ContentType[],
  contentType?: ContentType,
) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH, 'fetchContentTypes', { curState, channelNo, types, contentType })
  if (isCacheHit(getState().storeContentFilter[curState], cacheParam)) {
    return
  }

  const contents: NewsState[] = await Promise.all(
    types.map(type => {
      const newsParam: NewsParam = {
        storeId: channelNo,
        page: 1,
        pageSize: 1,
        contentType: type,
      }
      return fetchNews(newsParam)
    }),
  )
  const contentTypes = contents
    .filter(content => content.articles && content.articles.length)
    .map(content => content.contentType)

  dispatch({
    curState,
    channelNo,
    contentTypes,
    contentType,
    cacheParam,
    type: FETCH,
  })
}

export const setContentType = (curState: StateKey, contentType: ContentType) => {
  return {
    curState,
    contentType,
    type: SET,
  }
}

const contentTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        channelNo: action.channelNo,
        contentTypes: action.contentTypes,
        contentType: action.contentType,
        cacheParam: action.cacheParam,
      }
    case SET:
      return {
        ...state,
        cacheParam: null,
        contentType: action.contentType,
      }
    default:
      return state
  }
}

export default contentTypesReducer
